export default "__VITE_ASSET__897955c9__"